import { FC } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';

type ItemStatusProps = {
  status: boolean;
};

export const ItemStatus: FC<ItemStatusProps> = ({ status }) => (
  <Container className={status ? 'success' : 'error'}>
    <Icon name={status ? 'check' : 'exclamation-mark'} size="s16" />
  </Container>
);

const Container = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &&&.success {
    background: ${COLORS.systemForest100};
    color: ${COLORS.systemForest200};
  }

  &&&.error {
    background: ${COLORS.systemFlame100};
    color: ${COLORS.systemFlame200};
  }
`;
